class CartPageController {
    /*@ngInject*/
    constructor($log) {
        $log.debug('CartPageController initialized');
        this.$log = $log;

        this.clearFilteredSize();
    }

    clearFilteredSize() {
        let size = localStorage.getItem('selectedProductSize');
        if (size != null) {
            localStorage.removeItem('selectedProductSize');
        }
    }
}

export default CartPageController;
